import { useCreateEntity, useDeleteEntity } from '@abaninja/util-store';

import { grantAccess, revokeAccess } from '../connections/access';

export const useAccessStore = () => ({
  ...useCreateEntity(grantAccess),
  ...useDeleteEntity(revokeAccess),
});
